import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import "./Style.scss";
import { update2FAType } from "api/api_register2FA";
import Swal from "sweetalert2";
import { clearLocalStorage } from "utils/storage";

let videoRef;
let canvasRef;
let context;

function Register2FAFace() {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL_PYTHON;
  const [lastFrame, setLastFrame] = useState(null);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const { username } = JSON.parse(localStorage.getItem("user")) || "";

  const update2FA = async (typeFA) => {
    await update2FAType(username, typeFA);
  };

  const registerNewUserOk = async (text) => {
    if (lastFrame) {
      const apiUrl = `${API_BASE_URL}/register_new_user?text=${text}`;
      console.log(typeof lastFrame);
      const data = await fetch(lastFrame);
      const blob = await data.blob();
      const file = new File([blob], "webcam-frame.png", {
        type: "image/png",
      });
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await axios.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.registration_status === 200) {
          update2FA(7);
          Swal.fire({
            title: "Xác minh 2 bước đã được bật",
            icon: "success",
          });
          setTimeout(() => {
            clearLocalStorage();
            window.location.href = "/authentication/sign-in";
          }, 1500);
        }
      } catch (error) {
        console.error("Error sending image to API:", error);
      }
    }
  };

  useEffect(() => {
    if (isNextClicked && lastFrame) {
      registerNewUserOk(username);
      setIsNextClicked(false);
    }
  }, [isNextClicked, lastFrame]);

  const handleNextClick = () => {
    context = canvasRef.current.getContext("2d");
    context.drawImage(videoRef.current, 0, 0, 400, 300);

    requestAnimationFrame(() => {
      setTimeout(() => {
        context.drawImage(videoRef.current, 0, 0, 400, 300);

        canvasRef.current.toBlob((blob) => {
          setLastFrame(URL.createObjectURL(blob));
          setIsNextClicked(true);
        });
      }, 33);
    });
  };

  return (
    <Box width={460} className="form-container">
      <Box className="fs-20 fw-700">Xác thực qua khuôn mặt</Box>
      <Box p={1} className="fs-14 txt-align">
        Nhìn vào camera và nhấn nút để chụp ảnh khuôn mặt
      </Box>
      <Webcam lastFrame={lastFrame} setLastFrame={setLastFrame} />
      <Box
        className="centered fs-14"
        style={{
          marginTop: "20px",
          width: "40%",
          height: "36px",
          background: "var(--blue-blue-100)",
          borderRadius: "6px",
          color: "white",
          cursor: "pointer",
        }}
        role="button"
        tabIndex="0"
        onClick={handleNextClick}
        onKeyDown={() => {}}
      >
        Tiếp theo
      </Box>
    </Box>
  );
}

function Webcam() {
  videoRef = useRef(null);
  canvasRef = useRef(null);
  const [isStreaming, setIsStreaming] = useState(false);

  useEffect(() => {
    const setupCamera = async () => {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      setIsStreaming(true);
    };
    if (!isStreaming) {
      setupCamera();
    }
  }, [isStreaming]);

  return (
    <div className="webcam">
      <canvas className="canvas" ref={canvasRef} width={400} height={300} />
      <video ref={videoRef} autoPlay playsInline>
        <track kind="captions" />
      </video>
    </div>
  );
}

export default Register2FAFace;
